import { RouterProvider } from 'react-router-dom';

// project imports
import router from 'routes';
import ThemeCustomization from 'themes';

import ScrollTop from 'components/ScrollTop';
import { NotificationProvider } from 'contexts/NotificationContext';

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {
  return (
    <ThemeCustomization>
      <NotificationProvider>
        <ScrollTop>
          <RouterProvider router={router} />
        </ScrollTop>
      </NotificationProvider>
    </ThemeCustomization>
  );
}
